import { cn } from "@/utils/styles";

export type TextAreaProps = {
  value?: string;
  disabled?: boolean;
  name: string;
  id?: string;
  rows?: number;
  placeholder?: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: boolean;
  className?: string;
};

export default function TextArea({
  onChange,
  value = "",
  name,
  id,
  placeholder,
  rows = 6,
  error,
  className = "",
  disabled,
  onFocus,
  onBlur
}: TextAreaProps) {
  return (
    <textarea
      id={id}
      value={value}
      name={name}
      rows={rows}
      disabled={disabled}
      style={{ boxShadow: "none" }}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      className={cn(
        "subtext-small w-full resize-none rounded-[8px] border border-gray-dark-200 bg-background px-3 py-[10px] text-foreground transition-colors placeholder:text-muted-foreground",
        className,
        error ? "border-red-dark-300" : ""
      )}
    />
  );
}
